import { useState } from "react";

export type FormController<F extends Record<string, any>> = ReturnType<typeof useFormController<F>>;

type FormControllerOptions<F extends Record<string, any>> = {
  onChange?: (nextFieldData: F, updatedKey: keyof F) => void;
};

export const useFormController = <F extends Record<string, any>>(
  initState: F | (() => F),
  options?: FormControllerOptions<F>
) => {
  const [fieldData, setFieldData] = useState<F>(initState);

  const onFieldChange = <K extends keyof F>(key: K, value: F[K]) => {
    setFieldData(prevData => {
      const nextData = { ...prevData, [key]: value };
      options?.onChange?.(nextData, key);
      return nextData;
    });
  };

  return {
    fieldData,
    setFieldData,
    onFieldChange
  };
};
